import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import StickyHeader from 'components/StickyHeader'
import Mixin from 'components/common/Mixin'
import StickyHeaderWrapper from 'components/common/StickyHeaderWrapper'
import { MAIN_CONTENT, FOOTER } from 'constant'

const StoreLocatorPage = ({
  placeholders: {
    header = [],
    mainContent = [],
    footer = []
  }
}) =>
  <React.Fragment>
    <StickyHeaderWrapper>
      { header }
      <StickyHeader />
    </StickyHeaderWrapper>
    <Wrapper id={ MAIN_CONTENT } tabIndex="-1" data-max-width data-max-width-padding>
      { mainContent }
    </Wrapper>
    <div id={ FOOTER }>
      { footer }
    </div>
  </React.Fragment>

StoreLocatorPage.propTypes = {
  placeholders: PropTypes.shape({
    footer: PropTypes.array,
    header: PropTypes.array,
    mainContent: PropTypes.array
  })
}

export default StoreLocatorPage

const Wrapper = styled.main`
  ${Mixin.responsive('margin', '24px auto', '5px auto')}
  ${Mixin.responsive('padding', '0 50px 24px', '0 16px')}
`
